import isEmpty from "lodash/isEmpty";
import { FiltersV2TermSearch, useFiltersV2Store } from "PFApp/components/filters_v2";
import { NoShortlistsPlaceholder } from "PFApp/components/resource_table_toggle/components/shortlists_panel/no_shortlists_placeholder";
import { SearchEntity } from "PFApp/components/search_autocomplete/search_autocomplete.types";
import { Activity, Id } from "PFTypes";
import { KnownFiltersV2 } from "PFTypes/filters_v2";
import { RecentSearchesPageKey } from "PFTypes/recent_searches";

import { useShortlistItems } from "../../hooks/use_shortlist_items";
import { RenderActionCell, RowSelection } from "../../resource_table_toggle";
import { ShortlistsTable } from "./shortlists_table";

type ShortlistsPanelProps = RowSelection & {
  activity: Activity;
  pageKey: RecentSearchesPageKey;
  renderActionCell?: RenderActionCell;
  onShortlistUndo?: (shortlistId: Id) => void;
};

export const ShortlistsPanel = ({
  activity,
  pageKey,
  onRowSelectionChange,
  rowSelectionState,
  renderActionCell,
  onShortlistUndo
}: ShortlistsPanelProps) => {
  const { tableData, isLoading, isFetching, isError } = useShortlistItems({ activityId: activity.id });

  const termFilter = useFiltersV2Store((state) => state.mainFilters[KnownFiltersV2.Term]);
  const shortlistsSearchEnabled = !!termFilter;
  const isShortlistsEmpty = isEmpty(tableData);

  return (
    <>
      <FiltersV2TermSearch
        disabled={!shortlistsSearchEnabled}
        autocompleteConfig={[{ entity: SearchEntity.Profile, useAsTerm: true }]}
        pageKey={pageKey}
        fullWidth
      />
      {!isError && isShortlistsEmpty && <NoShortlistsPlaceholder />}
      {!isError && !isShortlistsEmpty && (
        <ShortlistsTable
          activity={activity}
          tableData={tableData}
          isLoading={isLoading}
          isFetching={isFetching}
          onRowSelectionChange={onRowSelectionChange}
          rowSelectionState={rowSelectionState}
          renderActionCell={renderActionCell}
          onShortlistUndo={onShortlistUndo}
        />
      )}
    </>
  );
};
